import React, { useEffect, useState } from "react";
import { View, Flex, useTheme, Loader, Alert } from "@aws-amplify/ui-react";
import ProfileHeader from "./ProfileHeader";
import "./Profile.css";
import { getCurrentUserInfo } from "../../data/api";
import { UserRole } from "@/data/interfaces";
import ProfilePassword from "./ProfilePassword";
import ProfileEmail from "./ProfileEmail";

interface ProfileAttributes {
  name?: string;
  email?: string;
  role?: UserRole;
}

const Profile = () => {
  const { tokens } = useTheme();
  const defaultAttributes: ProfileAttributes = {name: "", email: ""};
  const [data, setData] = useState(defaultAttributes);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getUserInfo = async () => {
    try{
      setLoading(true);
      setError(false);
      const attributes = await getCurrentUserInfo();
      attributes.role = attributes['custom:role'];
      setData(attributes);
      setLoading(false);
    } catch (e) {
      console.log('Loading profile information failed ', e);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <>
      <View maxWidth="100%" padding="0rem" minHeight="100vh">
        <Flex
          direction={{ base: "column", large: "row" }}
          alignItems="flex-start"
          gap={tokens.space.xl}
          marginBottom="30px"
        >
          <View
            backgroundColor="var(--amplify-colors-white)"
            borderRadius="6px"
            width={{ base: "100%", large: "100%" }}
            padding="1rem"
          >
            {loading ? <Loader/> : error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : <ProfileHeader name={data.name} email={data.email} role={data['custom:role']}/>}
          </View>
        </Flex>

        <Flex
          direction={{ base: "column", large: "row" }}
          gap={tokens.space.xl}
          alignItems="flex-start"
          marginBottom="30px"
        >
          <View
            backgroundColor="var(--amplify-colors-white)"
            borderRadius="6px"
            width={{ base: "100%", large: "100%" }}
            padding={{ base: "1em", large: "1.5rem" }}
          >
            <ProfileEmail onUpdate={getUserInfo} />
          </View>
        </Flex>

        <Flex
          direction={{ base: "column", large: "row" }}
          gap={tokens.space.xl}
          alignItems="flex-start"
        >
          <View
            backgroundColor="var(--amplify-colors-white)"
            borderRadius="6px"
            width={{ base: "100%", large: "100%" }}
            padding={{ base: "1em", large: "1.5rem" }}
          >
            <ProfilePassword />
          </View>
        </Flex>
      </View>
    </>
  );
};

export default Profile;